import { render, staticRenderFns } from "./ClinicShowBankOrder.vue?vue&type=template&id=b0e3bc4c"
import script from "./ClinicShowBankOrder.vue?vue&type=script&lang=js"
export * from "./ClinicShowBankOrder.vue?vue&type=script&lang=js"
import style0 from "./ClinicShowBankOrder.vue?vue&type=style&index=0&id=b0e3bc4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports